import React from 'react';
import { Row, Col } from 'antd';
import SpeedSign from '../../SpeedSign';
import { Location, UnitOfMeasurement, UnitOfSpeed } from '../../../types/types';
import { convertSpeed } from '../../../core/utils/mathUtils';
import AddressFetcher from '../../elements/AddressFetcher';
import { Location as LocationIcon, Time, User } from '@carbon/icons-react';

import './eventPopup.scss';

interface EventPopupProps {
    speed: number;
    speedUnit: UnitOfSpeed;
    eventLabel: string;
    time: string;
    driverId: string| number;
    driverName: string;
    location: Location;
    uomPref: UnitOfMeasurement;
}

/**
 * Renders an event popup for an event marker. Created with data provided.
 */
const EventPopup: React.FC<EventPopupProps> = ({
    speed,
    speedUnit,
    eventLabel,
    time,
    driverId,
    driverName,
    location,
    uomPref,
}) => {
    return (
        <div className='event-popup'>
            <Row>
                <Col xs={3}>
                    <SpeedSign 
                        speed={convertSpeed(speed, speedUnit, uomPref)} 
                        isMetric={uomPref === UnitOfMeasurement.Metric || false}
                    />
                </Col>
                <Col xs={21}>
                    <h3 className='name'>{eventLabel.trim()}{eventLabel.toLowerCase().includes('event') ? '' : ' Event'}</h3>
                </Col>
                <Col xs={20}>
                    <div className='metadata'>
                        <div className='time'>
                            <Time 
                                size={12}
                                color='var(--cool-gray-60)'
                            />
                            &ensp;
                            {time}
                        </div>
                        <div className='driver-name'>
                            <User 
                                size={12}
                                color='var(--cool-gray-60)'
                            />
                            &ensp;
                            <a 
                                href={Number(driverId) > 0 ? `/drivers/view/${Number(driverId)}` : '#'} 
                                target="_blank"
                                rel="noreferrer"
                            >
                                {driverName}
                            </a>
                        </div>
                        <div className='lat-lng'>
                            <LocationIcon 
                                size={12}
                                color='var(--cool-gray-60)'
                            />
                            &ensp;
                            <div>{location.lat}, {location.lng}</div>
                        </div>
                        <div className='address'>
                            <AddressFetcher
                                lat={location.lat}
                                lng={location.lng}
                                useAlternativeIcon
                            />  
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default React.memo(EventPopup);